<template>
    <solid-box
        :priceRate="tradeSum.priceRate[transferVariety]"
        :title="moduleName"
    >
        <div ref="container" class="container" v-auto-size />
    </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'
import { getRelativelySize } from '@/utils/size'

/**
 * 林权
 */
export default {
    echartsInstance: null,
    components: {
        SolidBox
    },
    props: {
        moduleName: {
            type: String,
            default: ''
        },
        transferVariety: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tradeSum: {
                priceRate: {
                    LQ: ''
                }
            }
        }
    },
    destroyed() {
        if (this.echartsInstance) {
            this.echartsInstance.dispose()
        }
    },
    mounted() {
        this.$eventHub.$on('tradeChange', (tradeSum) => {
            if (tradeSum) {
                this.tradeSum = tradeSum
            }
            this.init()
        })
    },
    methods: {
        init() {
            if (this.echartsInstance) {
                this.echartsInstance.dispose()
            }
            const charInstance = echarts.init(this.$refs['container'])
            this.echartsInstance = charInstance
            this.setEchartOption()
        },
        setEchartOption() {
            this.echartsInstance.setOption(this.getOptions(), {
                notMerge: true
            })
        },
        delStr(str, num) {
            if (Number(str)) {
                return Number(str).toFixed(num)
            } else {
                return str ? Number(str.replace(/,/g, '')).toFixed(num) : ''
            }
        },
        getOptions() {
            return {
                grid: {
                    top: getRelativelySize(35),
                    left: getRelativelySize(5),
                    right: getRelativelySize(5),
                    bottom: getRelativelySize(35)
                },
                xAxis: {
                    offset: getRelativelySize(8),
                    data: [
                        this.tradeSum.ctype + '金额(万元)',
                        this.tradeSum.ctype + '笔数(笔)',
                        this.tradeSum.ctype + '面积(亩)'
                    ],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(73,95,120,1)',
                            width: 1 // 这里是为了突出显示加上的
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',
                            fontSize: getRelativelySize(16)
                        }
                    }
                },
                yAxis: [
                    {
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(73,95,120,1)',
                                width: 1 // 这里是为了突出显示加上的
                            }
                        },
                        axisLabel: {
                            show: false,
                            textStyle: {
                                color: '#ffffff',
                                fontSize: getRelativelySize(16)
                            }
                        },
                        splitArea: {
                            areaStyle: {
                                color: 'rgba(255,255,255,.5)'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(73,95,120,1)',
                                width: 1
                            }
                        }
                    },
                    {
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(73,95,120,1)',
                                width: 1 // 这里是为了突出显示加上的
                            }
                        },
                        axisLabel: {
                            show: false,
                            textStyle: {
                                color: '#ffffff'
                            }
                        },
                        splitArea: {
                            areaStyle: {
                                color: 'rgba(255,255,255,.5)'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(73,95,120,1)',
                                width: 1
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: 'hill',
                        type: 'pictorialBar',
                        barCategoryGap: '55%',
                        symbol: 'triangle',
                        label: {
                            show: true,
                            position: 'top',
                            distance: getRelativelySize(5),
                            color: '#FFFFFF',
                            fontWeight: 'none',
                            border: '10px solid red',
                            fontSize: getRelativelySize(16)
                        },
                        data: [
                            {
                                value:
                                    this.delStr(
                                        this.tradeSum.money[
                                            `tradeAmount_${this.transferVariety}`
                                        ],
                                        2
                                    ) || 0.0,
                                itemStyle: {
                                    normal: {
                                        color: {
                                            type: 'linear',
                                            x: 0,
                                            y: 0,
                                            x2: 0,
                                            y2: 1,
                                            colorStops: [
                                                {
                                                    offset: 0,
                                                    color: 'rgba(230,173,8, 1)' //  100%  处的颜色
                                                },
                                                {
                                                    offset: 1,
                                                    color:
                                                        'rgba(247,107,28, .2)' //  0%  处的颜色
                                                }
                                            ],
                                            global: false //  缺省为  false
                                        }
                                    },
                                    emphasis: {
                                        opacity: 1
                                    }
                                }
                            },
                            {
                                value:
                                    this.delStr(this.tradeSum.count.lq, 0) || 0,
                                itemStyle: {
                                    normal: {
                                        color: {
                                            type: 'linear',
                                            x: 0,
                                            y: 0,
                                            x2: 0,
                                            y2: 1,
                                            colorStops: [
                                                {
                                                    offset: 0,
                                                    color: 'rgba(0,175,108, 1)' //  100%  处的颜色
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(0,175,108, .2)' //  0%  处的颜色
                                                }
                                            ],
                                            global: false //  缺省为  false
                                        }
                                    },
                                    emphasis: {
                                        opacity: 1
                                    }
                                }
                            },
                            {
                                value:
                                    this.delStr(this.tradeSum.area.lq, 2) ||
                                    0.0,
                                itemStyle: {
                                    normal: {
                                        color: {
                                            type: 'linear',
                                            x: 0,
                                            y: 0,
                                            x2: 0,
                                            y2: 1,
                                            colorStops: [
                                                {
                                                    offset: 0,
                                                    color: 'rgba(170,77,209, 1)' //  100%  处的颜色
                                                },
                                                {
                                                    offset: 1,
                                                    color:
                                                        'rgba(170,77,209, .2)' //  0%  处的颜色
                                                }
                                            ],
                                            global: false //  缺省为  false
                                        }
                                    },
                                    emphasis: {
                                        opacity: 1
                                    }
                                }
                            }
                        ],
                        z: 10
                    }
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    width: 540px;
    height: 215px;
    margin: 17px auto 0;
}

.total {
    font-size: 12px;
    color: #fff;
    line-height: 14px;
    position: absolute;
    left: 128px;
    top: 70px;

    > .unit {
        color: #ffa106;
        font-size: 16px;
    }
}
</style>
